<template>
  <div
    style="font-family: 'NanumBarunGothic'"
    class="winbox-selected-place-enabled"
  >
    <div class="winbox-selected-place-title noselect">
      <p class="title">
        <strong
          >{{ selectedPlace.NMS_NM }} /
          {{ selectedPlace.ARP_SE }}-{{
            selectedPlace.NMT_NO
          }}
        </strong>
      </p>
      <p class="sub">{{ selectedPlace.MARK_ADDR }}</p>
    </div>
    <div class="winbox-selected-place-map noselect">
      <div id="map" class="leaflet-container"></div>
    </div>

    <div class="winbox-selected-place-detail noselect">
      <!--
      <p><strong>측정국 소음 기준</strong></p>
      <div>
        <table
          style="width: 100%; margin-top: -5px; border: 1px solid whitesmoke"
        >
          <thead
            class="text-center"
            style="font-size: 12px; border: 1px solid whitesmoke"
          >
            <tr>
              <th>기준<br />활주로</th>
              <th>활주로<br />고도</th>
              <th>ICAO<br />소음기준</th>
              <th>거리보정<br />소음</th>
              <th>적용<br />소음기준</th>
            </tr>
          </thead>
          <tbody
            v-if="selectedPlace.pointInfo.length !== 0"
            class="text-center"
            style="font-size: 12px"
          >
            <tr
              v-for="value in selectedPlace.pointInfo"
              v-bind:key="value.STDR_RWY"
            >
              <td>{{ value.STDR_RWY }}</td>
              <td>{{ value.RWY_ALT }}</td>
              <td>{{ value.ICAO_STDR_NS }}</td>
              <td>{{ value.DSTNC_REVISN_NS }}</td>
              <td>{{ value.ICAO_STDR_NS + value.DSTNC_REVISN_NS }}</td>
            </tr>
          </tbody>
          <tbody v-else class="text-center" style="font-size: 12px">
            <tr>
              <td colspan="5">데이터 없음</td>
            </tr>
          </tbody>
        </table>
        <p class="text-right" style="font-size: 11px; margin-right: 10px">
          고도단위 : m / 소음단위 : db(A)
        </p>
      </div>
      -->
      <p v-if="selectedYear>=2023"><strong>측정국 월별 소음 정보(LdendB)</strong></p>
      <p v-else><strong>측정국 월별 소음 정보(WECPNL)</strong></p>
      <div class="text-right" style="margin-top: -40px; margin-right: 5px">
        <b-form-select
          class="text-center"
          style="width: 80px"
          size="sm"
          v-model="selectedYear"
          :options="yearOption"
        ></b-form-select>
      </div>
      <div>
        <div
          style="margin-left: -20px; margin-top: -5px; margin-right: 3px"
          id="chart"
        >
          <apexchart
            ref="apexChart"
            height="200px"
            width="100%"
            :options="chartOptions"
            :series="noiseSeries"
          ></apexchart>
        </div>
        <div style="margin-top: -15px">
          <table
            style="width: 100%; margin-top: -5px; border: 1px solid whitesmoke"
          >
            <thead
              class="text-center"
              style="font-size: 12px; border: 1px solid whitesmoke"
            >
              <tr v-if="selectedYear>=2023">
                <th>기준년월</th>
                <th>LdendB</th>
              </tr>
              <tr v-else>
                <th>기준년월</th>
                <th>WECPNL</th>
              </tr>
            </thead>
            <tbody class="text-center" style="font-size: 12px">
              <tr v-if="statistics.month1">
                <td>1월</td>
                <td>{{ statistics.month1 }}</td>
              </tr>
              <tr v-if="statistics.month2">
                <td>2월</td>
                <td>{{ statistics.month2 }}</td>
              </tr>
              <tr v-if="statistics.month3">
                <td>3월</td>
                <td>{{ statistics.month3 }}</td>
              </tr>
              <tr v-if="statistics.month4">
                <td>4월</td>
                <td>{{ statistics.month4 }}</td>
              </tr>
              <tr v-if="statistics.month5">
                <td>5월</td>
                <td>{{ statistics.month5 }}</td>
              </tr>
              <tr v-if="statistics.month6">
                <td>6월</td>
                <td>{{ statistics.month6 }}</td>
              </tr>
              <tr v-if="statistics.month7">
                <td>7월</td>
                <td>{{ statistics.month7 }}</td>
              </tr>
              <tr v-if="statistics.month8">
                <td>8월</td>
                <td>{{ statistics.month9 }}</td>
              </tr>
              <tr v-if="statistics.month9">
                <td>9월</td>
                <td>{{ statistics.month9 }}</td>
              </tr>
              <tr v-if="statistics.month10">
                <td>10월</td>
                <td>{{ statistics.month10 }}</td>
              </tr>
              <tr v-if="statistics.month11">
                <td>11월</td>
                <td>{{ statistics.month11 }}</td>
              </tr>
              <tr v-if="statistics.month12">
                <td>12월</td>
                <td>{{ statistics.month12 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormSelect } from "bootstrap-vue"
import { url } from "../config/url"
import { mode } from "../config/mode.js"
import axios from "axios"
import "leaflet/dist/leaflet.css"
import * as mapConfig from "..//config/map.js"
export default {
  props: ["selectedPlace"],
  data() {
    return {
      time: null,
      localTime: null,
      selectedYear: null,
      yearOption: [],
      leafletInstance: null,
      statistics: {},
      miniMapOptions: mapConfig.defaultMiniMapOptions,
      monthIndex: [
        "month1",
        "month2",
        "month3",
        "month4",
        "month5",
        "month6",
        "month7",
        "month8",
        "month9",
        "month10",
        "month11",
        "month12",
      ],
      noiseSeries: [
        {
          name: "db(A)",
          data: [],
          type: 'area',
        },
      ],
      chartOptions: {
        legend: {
          show : false,
        },
        chart: {

          toolbar: {
            show: false,
          },
          height: 350,
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
          borderColor: "white",
          strokeDashArray: 0,
          position: "back",
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        stroke: {
          curve: "smooth",
        },
        tooltip: {
          enabled: false,
        },
        yaxis: {
          labels: {
            style: {
              colors: [
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
              ],
            },
          },
          tooltip: {
            enabled: false,
            offsetX: 0,
          },
        },
        xaxis: {
          type: "category",
          categories: [
            "1월",
            "2월",
            "3월",
            "4월",
            "5월",
            "6월",
            "7월",
            "8월",
            "9월",
            "10월",
            "11월",
            "12월",
          ],
          tickPlacement: "on",
          max: 12,
          labels: {
            style: {
              colors: [
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
                "white",
              ],
            },
          },
        },
      },
    }
  },
  mounted() {
    this.selectedYear = new Date().getFullYear()
    for (let i = 0; i < 2; i++) {
      this.yearOption.push(this.selectedYear - i)
    }
    setTimeout(() => {
      this.loadMiniMap()
    }, 100)
  },
  watch: {
    selectedYear: function (newValue, oldValue) {
      this.getStatistic()
    },
    selectedPlace: function (newValue, oldValue) {
      this.loadMiniMap()
      this.getStatistic()
    },
  },
  components: {
    BFormSelect,
  },
  methods: {
    loadMiniMap: function () {
      if (this.leafletInstance !== null) {
        this.leafletInstance.remove()
      }
      let latlng = this.selectedPlace.GEOM.Point.pos.split(' ')
      let lat = latlng[1]
      let lng = latlng[0]

      this.leafletInstance = L.map("map", this.miniMapOptions).setView(
          {
            lat : lat, 
            lng : lng 
          }
      )
      
      let tileLayer = L.tileLayer.wms(
        url[mode.where].satMapServerLeaflet
      )
      tileLayer.addTo(this.leafletInstance)
    },
    getStatistic: function () {
      let name = this.selectedPlace["NMS_NM"]
      let number = this.selectedPlace["NMT_NO"]
      let airport = this.selectedPlace["ARP_SE"]
      this.statistics = {}
      axios
        .get(
          url[mode.where].noiseStatistic +
            "/" +
            airport +
            "/" +
            this.selectedYear
        )
        .then(response => {
          for (let i in response.data.response.body.items.item) {
            if (name === response.data.response.body.items.item[i]["name"]) {
              this.statistics = response.data.response.body.items.item[i]
            }
          }
          let array = []
          for (let j in this.monthIndex) {
            if (this.statistics[this.monthIndex[j]]) {
              array.push(this.statistics[this.monthIndex[j]])
            }
          }

          this.noiseSeries[0].data = JSON.parse(JSON.stringify(array))
          for (let j in this.noiseSeries[0].data){
            if(this.noiseSeries[0].data[j]==='') this.noiseSeries[0].data[j] = null
          }
          this.$refs.apexChart.updateSeries(
            this.noiseSeries,
            false,
            true
          )
        })
        .catch(err => {
          console.log("Failed to Receive Noise Measures", err)
        })
    },
  },
}
</script>

<style>
@import "../styles/main.css";
@import "../styles/ag-grid/styles/ag-grid.css";
@import "../styles/ag-grid/styles//ag-theme-dark.css";
</style>
